<template>
  <div
    class="reward-main bg-cent"
    :style="'backgroundImage: url(' + theme.images_temp + ');'"
  >
    <!-- <div class="bgfire" :style="location"> -->
    <div class="fire2" :style="item" v-for="item in location"></div>
    <!-- <div class="fire2"></div> -->
    <!-- </div> -->

    <audio loop ref="audio" :src="theme.music_temp"></audio>

    <!-- <div class="titlel"></div> -->

    <!-- <div class="titler"></div> -->
    <!-- <div class="titlebl"></div>
    <div class="titlebr"></div> -->

    <div class="reward-box">
      <a-carousel arrows :dots="false" :after-change="afterChange">
        <div
          slot="prevArrow"
          slot-scope="props"
          class="custom-slick-arrow"
          style="left: 2.5rem; zindex: 100"
        >
          <a-icon type="left-circle" style="font-size: 0.48rem" />
        </div>
        <div
          slot="nextArrow"
          slot-scope="props"
          class="custom-slick-arrow"
          style="right: 2.5rem"
        >
          <a-icon type="right-circle" style="font-size: 0.48rem" />
        </div>

        <div class="reward-chart" v-for="(item, index) in gift" :key="index">
          <div class="reward-chart-top btn-11">
            <div class="reward-img bg-cent">
              <img :src="item.images_temp" />
            </div>
            <h2 class="reward-text">
              {{ item.name }}
            </h2>
          </div>
        </div>
      </a-carousel>
      <!-- <div class="reward-stard position-absolute bg-cent" v-else key="edit">
					<div class="stard-name">
						<div class="stard-img">
							<div class="stard-bg"></div>
							<div class="stard-user" :style="'backgroundImage: url(' + personList[num].avatar_temp + ');'"></div>
						</div>
						{{personList[num].name}}
					</div>
				</div> -->

      <div class="reward-bottom">
        <div class="reward-b-l cp"></div>
        <div class="reward-b-r cp"></div>
        <!-- <div class="reward-bottom-guan">
						<img src="@/assets/image/activity/bgicon15.png" />
					</div>
					
					<div class="reward-bottom-guanC">
						<img src="@/assets/image/activity/bgicon15.png" />
					</div> -->

        <div class="reward-bottom-left bg-cent"></div>
        <div class="reward-bottom-box">
          <div class="reward-bottom-boxA">
            <!-- <a-icon type="caret-left" @click="nub(0)" /> -->
            <img
              class="caret-left"
              @click="nub(0)"
              src="@/assets/image/activity/01_slices/10.png"
            />
            <a-input-number
              id="inputNumber"
              v-model="value"
              :controls="false"
              :min="1"
              :readOnly="show"
              :disabled="!show"
              :max="10"
            />
            <img
              class="caret-right"
              @click="nub(1)"
              src="@/assets/image/activity/01_slices/11.png"
            />
            <!-- <a-icon type="caret-right" @click="nub(1)" /> -->
          </div>
        </div>
        <div class="reward-bottom-box">
          <div
            class="reward-bottom-boxB"
            @click="doAction"
            :style="{
              backgroundImage: show
                ? 'url(' +
                  require('@/assets/image/activity/01_slices/15.png') +
                  ')'
                : 'url(' +
                  require('@/assets/image/activity/03_slices/2.png') +
                  ')',
            }"
          >
            <!-- {{show ? '开始' : '暂停'}} -->
          </div>
        </div>
        <div class="reward-bottom-box">
          <div class="reward-bottom-boxC" @click="showUsersList = true"></div>
        </div>
      </div>
    </div>

    <!-- <div class="lucky animated bounceIn" v-if="!show">
			<img class="lucky-name" src="../../assets/image/activity/bgicon9.png" />
			<div class="lucky-icon" @click="showName = false"></div>
			<div class="lucky-mian">
				<div class="lucky-box">
					<div class="lucky-box-l">
						<div class="lucky-l-img bg-cent">
							<img :src="luckDog.avatar_temp" alt="ensure" />
						</div>
						<div class="lucky-l-name">{{luckDog.name}}</div>
					</div>
					<div class="lucky-box-r">
						{{luckDog.desire}}
					</div>
				</div>
			</div>
		</div> -->
    <div class="open-lucky" v-if="!show">
      <div class="box" v-for="(item, index) in value" :key="index">
        <div
          class="open-lucky-box"
          :class="luckDog.length > 4 ? 'open-lucky-boxA' : ''"
        ></div>
        <!-- [0] -->
        <img
          :class="luckDog.length > 4 ? 'open-lucky-imgA' : ''"
          :src="personList[numAry[index]].avatar_temp"
        />
      </div>
    </div>

    <div class="lucky animated bounceIn" v-if="showUsers">
      <img class="lucky-name" src="@/assets/image/activity/02_slices/7.png" />
      <div class="lucky-icon" @click="showUsers = false"></div>
      <div class="lucky-user-box">
        <div class="lucky-user-list">
          <h3>{{ gift[rewardType].name }}（{{ value }}名）</h3>
          <div class="lucky-user-list-cent">
            <div
              class="lucky-cent animated fadeInUp"
              :style="animationDelay(idx, 0.3)"
              v-for="(ele, idx) in luckDog"
              :key="idx"
            >
              <div class="img" :class="luckDog.length > 3 ? '' : 'imgA'">
                <!-- <div class="zc" v-if="ele.status == 1">
                  <img src="@/assets/image/activity/03_slices/zc2.png" />
                </div> -->
                <img :src="ele.avatar_temp" />
                <span>{{ ele.name }}</span>
                <div class="text">
                  <span>公司：{{ ele.company_name }}</span>
                  <span>部门：{{ ele.dept_name }}</span>
                  <!-- <span>祝福语: {{ ele.desire }}</span> -->
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- uper -->
      <img
        class="uper4 animated fadeInUp"
        :style="animationDelay(1, 0.6)"
        src="@/assets/image/activity/02_slices/4.png"
      />
      <img
        class="uper2 animated fadeInUp"
        :style="animationDelay(1, 1.2)"
        src="@/assets/image/activity/02_slices/2.png"
      />
      <img
        class="uper1 animated fadeInUp"
        :style="animationDelay(1, 1.8)"
        src="@/assets/image/activity/02_slices/1.png"
      />
    </div>

    <div class="lucky animated bounceIn" v-if="showUsersList">
      <img class="lucky-name" src="@/assets/image/activity/02_slices/7.png" />
      <div class="lucky-icon" @click="showUsersList = false"></div>
      <div class="lucky-user-box">
        <a-carousel arrows>
          <div
            slot="prevArrow"
            slot-scope="props"
            class="custom-slick-arrow"
            style="left: 10px; zindex: 1000"
          >
            <a-icon type="left-circle" />
          </div>
          <div
            slot="nextArrow"
            slot-scope="props"
            class="custom-slick-arrow"
            style="right: 10px"
          >
            <a-icon type="right-circle" />
          </div>
          <div
            class="lucky-user-list"
            v-for="(item, index) in userData"
            :key="index"
          >
            <h3>{{ item.name }}</h3>
            <div class="lucky-user-list-cent">
              <div
                class="lucky-cent animated fadeInLeftBig"
                style="width: 18%"
                :style="animationDelay(idx, 0.1)"
                v-for="(ele, idx) in item.ary"
                :key="idx"
              >
                <!-- <div class="zc" v-if="ele.status == 1">
                  <img src="@/assets/image/activity/03_slices/zc2.png" />
                </div> -->

                <div class="img">
                  <img
                    :src="
                      ele.avatar
                        ? ele.avatar_temp
                        : require('@/assets/image/activity/mockHead.png')
                    "
                  />
                  <span>{{ ele.name }}</span>
                  <div class="text">
                    <span>公司：{{ ele.company_name }}</span>
                    <span>部门：{{ ele.dept_name }}</span>
                    <!-- <span>祝福语: {{ele.desire}}</span> -->
                  </div>
                </div>
                <!-- <div class="text">
									<span>部门：{{ele.company_name}}</span>
									<span>公司：{{ele.dept_name}}</span>
									<span>祝福语: {{ele.desire}}</span>
								</div> -->
              </div>
            </div>
          </div>
        </a-carousel>
      </div>
    </div>
  </div>
</template>

<script>
var docEl = document.documentElement;
var clientWidth = docEl.clientWidth;
var baseFontSize = 100;
var designWidth = 1920;
var currentFontSize = (clientWidth / designWidth) * baseFontSize;
// console.log(currentFontSize)
docEl.style.fontSize = currentFontSize + "px";
let timer = null;
import debounce from "@/assets/js/debounce.js";
export default {
  data() {
    return {
      showUsers: false,
      show: true,
      showName: false,
      showUsersList: false,
      rewardAry: ["三等奖", "二等奖", "一等奖"],
      rewardType: 0,
      dataurl: "",
      img: require("@/assets/image/46.png"),
      theme: {
        name: "",
      },
      personList: [],
      gift: [
        {
          images_temp: "",
          name: "",
        },
      ],
      nowGift: {},
      timer: "",
      num: 0,
      numAry: [0],
      luckDog: [],
      luckDogDemo: [],
      userData: [],
      value: 1,
      location: [],
    };
  },
  filters: {
    getName(val) {
      let arr = val.split("，");
      return arr[0];
    },
    getName1(val) {
      let arr = val.split("，");
      return arr[1];
    },
  },
  mounted() {
    this.getLuckTheme();
    // this.getLuckRoster() ;
    this.getLuckPrizes();
    this.fireworks();
  },
  methods: {
    // 烟花
    fireworks() {
      setInterval(() => {
        for (let i = 0; i < 5; i++) {
          let time = Math.floor(Math.random() * 10 - 1);
          this.$set(this.location, i, this.setFireworks());
        }
      }, 1500);
    },
    setFireworks() {
      // 获得屏幕宽高
      let screenWidth = document.body.clientWidth; // 屏幕宽
      let screeHeight = document.body.clientHeight;
      let left = Math.floor(Math.random() * screenWidth - 1);
      let top = Math.floor(Math.random() * screeHeight - 1);
      left = screenWidth - left < 400 ? screenWidth - 400 : left;
      top = screeHeight - top < 400 ? screeHeight - 400 : top;

      let width = Math.floor(Math.random() * 200 - 1);
      let heigth = Math.floor(Math.random() * 200 - 1);
      // console.log(screenWidth,screeHeight,left,top)
      return "left:" + left + "px;top:" + top + "px";
    },
    afterChange(e) {
      this.rewardType = e;
    },

    beforeChange(e) {
      // console.log(e)
    },
    animationDelay(index, time = 0.1) {
      return "animationDelay:" + time * index + "s;";
    },
    nub(val) {
      if (!this.show) return;
      if (val) {
        this.value = this.value++ == 10 ? 10 : this.value++;
      } else {
        this.value = this.value-- == 0 ? 1 : this.value--;
      }
    },
    // 获取中奖名单
    getLuckDraw() {
      this.$refs.audio.currentTime = 0;
      this.$refs.audio.play();
      timer = setInterval(() => {
        var num = Math.floor(Math.random() * this.personList.length - 1);
        this.num = num;
        // let numAry = [];
        for (let i = 0; i < this.value; i++) {
          // numAry.push(Math.floor(Math.random() * this.personList.length - 1));
          this.$set(
            this.numAry,
            i,
            Math.floor(Math.random() * this.personList.length - 1)
          );
        }
        // this.numAry = numAry
        // console.log(numAry)
      }, 50);

      this.$api
        .getLuckDraw({
          prize: this.gift[this.rewardType].id,
          page: this.value,
        })
        .then((res) => {
          this.luckDog = res.data;
          this.getLuckRoster();
          this.showName = false;
          this.show = !this.show;
        })
        .catch((err) => {
          // console.log('fusiwen1234456', err);
          alert(err.message);
        });
    },
    //获取奖项
    getLuckPrizes() {
      this.$api.getLuckPrizes().then((res) => {
        this.gift = res.data;
        this.nowGift = this.gift.length == 0 ? [] : this.gift[0];
        this.getLuckRoster();
      });
    },
    getLuckRoster() {
      this.$api.getLuckRoster().then((res) => {
        this.personList = res.data;
        let data = [];
        let gift = [...this.gift];
        // 4
        // 4 * 10
        gift.forEach((item, index) => {
          data.push({
            win: item.id,
            name: item.name,
            ary: [],
          });
          this.personList.forEach((ele) => {
            if (item.id == ele.win) {
              data[index].ary.push(ele);
            }
          });
        });
        this.userData = data;
        // console.log(this.userData);
      });
    },
    getLuckTheme() {
      this.$api.getLuckTheme().then((res) => {
        this.theme = res.data;
      });
    },
    doAction() {
      debounce(this.control, 500); //防抖
    },
    control() {
      clearInterval(timer);
      let time = this.show ? 1 : 100;
      setTimeout(() => {
        if (this.show) {
          this.getLuckDraw();
        } else {
          this.$refs.audio.pause();
          // let numAry = [];
          // this.personList.forEach((item, index) => {
          // 	this.luckDog.forEach((ele, idx) => {
          // 		if (ele.id == item.id) {
          // 			numAry.push(index)
          // 		}
          // 	})

          // })
          // this.numAry = numAry;

          // setTimeout(() => {

          this.showUsers = true;
          this.showName = true;
          this.show = !this.show;

          // }, 500)
        }
      }, time);
    },
    caret(e) {
      let rewardType = this.rewardType;
      let self = this;
      e ? add() : reduce();

      function add() {
        self.rewardType =
          self.rewardType == self.gift.length - 1 ? 0 : rewardType + 1;
      }

      function reduce() {
        self.rewardType =
          self.rewardType == 0 ? self.gift.length - 1 : rewardType - 1;
      }
    },
  },
};
</script>

<style lang="scss" scoped="scoped">
.fire,
.fire2 {
  position: absolute;
  top: 0;
  left: 0;
  // background: url('av') no-repeat;
  background-image: url(../../assets/image/activity/01_slices/8.png);
  background-size: contain;
  width: 200px;
  height: 200px;
  box-sizing: border-box;
  background-clip: content-box;
  border-radius: 100%;
}

.fire {
  animation: firing 1.5s ease infinte;
  -webkit-animation: firing 1.5s ease infinite;
}

.fire2 {
  animation: firing2 1.5s ease infinte;
  -webkit-animation: firing2 1.5s ease infinite;
}

@keyframes firing {
  0% {
    padding: 80px;
    transform: scale(0.5) translateY(0);
    opacity: 1;
  }

  75% {
    padding: 0;
    transform: scale(1) translateY(0);
  }

  100% {
    opacity: 0;
    transform: scale(1) translateY(100px);
  }
}

@-webkit-keyframes firing {
  0% {
    padding: 80px;
    -webkit-transform: scale(0.5) translateY(0);
    opacity: 1;
  }

  75% {
    padding: 0;
    -webkit-transform: scale(1) translateY(0);
  }

  100% {
    opacity: 0;
    -webkit-transform: scale(1) translateY(100px);
  }
}

@keyframes firing2 {
  0% {
    padding: 80px;
    -webkit-transform: scale(0.5) translate(0);
    opacity: 1;
  }

  50% {
    opacity: 0.5;
  }

  100% {
    opacity: 0;
    -webkit-transform: scale(1);
  }
}

@-webkit-keyframes firing2 {
  0% {
    padding: 80px;
    -webkit-transform: scale(0.5) translate(0);
    opacity: 1;
  }

  50% {
    opacity: 0.5;
  }

  100% {
    opacity: 0;
    -webkit-transform: scale(1);
  }
}

@font-face {
  font-family: "HYShangWeiShouShuW";
  src: url(../../assets/font/HYShangWeiShouShuW.ttf);
  font-weight: normal;
  font-style: normal;
}

.position-relative {
  position: relative;
}

.position-absolute {
  position: absolute;
}

.top-0 {
  top: 0;
}

.left-0 {
  left: 0;
}

.cp {
  cursor: pointer;
}

.show-enter-active,
.show-leave-active {
  transition: all 1s;
}

.show-enter,
.show-leave-to {
  margin-left: 50px;
  opacity: 0;
}

.show-enter-to,
.show-leave {
  margin-left: 0px;
}

.bg-cent {
  /* background-color: #fff; */
  background-repeat: no-repeat;
  background-size: cover;
  -webkit-background-size: cover;
  -o-background-size: cover;
  background-position: center 0;
}

.reward-main {
  width: 100vw;
  height: 100vh;
  background-color: crimson;
  position: relative;
  left: 0;
  top: 0;

  .titlel {
    width: 5.63rem;
    height: 0.64rem;
    position: absolute;
    top: 0.3rem;
    left: 0.55rem;
    background-image: url(../../assets/image/activity/logo.png);
    background-size: 100% 100%;
  }

  .titler {
    width: 5.78rem;
    height: 2.54rem;
    position: absolute;
    top: 0.1rem;
    right: 0;
    background-image: url(../../assets/image/activity/01_slices/7.png);
    background-size: 100% 100%;
  }

  // .titlebl {
  //   width: 350px;
  //   height: 390px;
  //   background-image: url(../../assets/image/activity/01_slices/2.png);
  //   background-size: 100% 100%;
  //   position: absolute;
  //   bottom: 0.78rem;
  //   left: 0.5rem;
  // }

  // .titlebr {
  //   width: 2.8rem;
  //   height: 2.84rem;
  //   background-image: url(../../assets/image/activity/01_slices/s1.png);
  //   background-size: 100% 100%;
  //   position: absolute;
  //   bottom: 0.86rem;
  //   right: 0.7rem;
  // }

  .logo {
    position: absolute;
    right: 2%;
    top: 3%;
    width: 18%;

    img {
      width: 100%;
    }

    & > p {
      position: absolute;
      font-size: 0.55rem;
      font-family: HYShangWeiShouShuW;
      color: #ffffff;
    }

    .text1 {
      top: 0;
      left: 0;
    }

    .text2 {
      right: 0;
      bottom: 0;
    }
  }

  .reward-box {
    position: absolute;
    // height: 5.1rem;
    // width: 100%;
    // top: calc(50% - 96.2656px);
    // margin-top: -300px;
    // top: 1rem;
    width: 11.1rem;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);

    .ant-carousel .slick-prev,
    .ant-carousel .slick-next {
      // background-color: red;
    }

    .reward-chart {
      display: flex !important;
      align-items: center;
      justify-content: center;

      .reward-img {
        height: 3.2rem;
        border: 0.05rem solid #ffe087;
        display: flex;
        align-items: center;
        justify-content: center;
        border-radius: 0.1rem;

        img {
          max-width: 80%;
          max-height: 90%;
        }
      }

      .reward-text {
        margin-top: 0.35rem;
        font-size: 0.36rem;
        text-shadow: 0 0 0.5rem #ff8a00;
        // line-height: 0.36rem;
        color: #ffffff;
        text-align: center;
      }
    }

    .reward-chart-top {
      width: 3.9rem;
      height: 5.1rem;
      border-radius: 10px;
      border-color: #ffe087;
      box-shadow: 0 0 0 0 #ff8a00, 0 0 7.3125rem 0 transparent;
      padding: 0.5rem;
      background-image: url(../../assets/image/activity/01_slices/13.png);
      background-size: 100% 100%;
    }
  }

  .reward-bottom {
    margin-top: 1rem;
    position: relative;
    width: 11.1rem;
    height: 1.3rem;
    // background-color: rgba(0, 0, 0, 0.4);
    // left: 50%;
    // margin-left: -5.55rem;
    // bottom: 10%;
    display: flex;
    justify-content: center;
    align-items: center;
    // overflow: hidden;
    background-image: url(../../assets/image/activity/01_slices/6.png);
    background-size: 100% 100%;

    .reward-b-r {
      width: 0.5rem;
      height: 0.5rem;
      position: absolute;
      left: -0.65rem;
      // background-color: #E02AFF;
      background-image: url(../../assets/image/activity/01_slices/16.png);
      background-size: 100% 100%;
    }

    .reward-b-l {
      width: 0.5rem;
      height: 0.5rem;
      position: absolute;
      right: -0.65rem;
      // background-color: #E02AFF;
      background-image: url(../../assets/image/activity/01_slices/16.png);
      background-size: 100% 100%;
    }

    .reward-bottom-guan {
      position: absolute;
      width: 1rem;
      top: -0.1rem;
      // height: 0.01rem;
      left: -1rem;
      animation: guanaaa 2s infinite linear;
      -webkit-animation: guanaaa 2s infinite linear;
    }

    .reward-bottom-guanB {
      position: absolute;
      width: 1rem;
      top: -1rem;
      left: calc(100% - 0.5rem);
      transform: rotate(90deg);
      animation: guanB 2s 2s infinite linear;
      -webkit-animation: guanB 2s 2s infinite linear;
    }

    .reward-bottom-guanC {
      position: absolute;
      width: 1rem;
      bottom: -0.1rem;
      right: -1rem;
      transform: rotate(180deg);
      animation: guanC 2s infinite linear;
      -webkit-animation: guanC 2s infinite linear;
    }

    @keyframes guanaaa {
      0% {
        left: -1rem;
      }

      100% {
        left: 100%;
      }
    }

    @keyframes guanB {
      0% {
        top: -1rem;
      }

      100% {
        top: 100%;
      }
    }

    @keyframes guanC {
      0% {
        right: -1rem;
      }

      100% {
        right: 100%;
      }
    }

    // .reward-bottom-left{
    // 	width: 0.3rem;
    // 	height: 1.7rem;
    // 	// background-color: red;
    // 	left: -0.15rem;
    // 	// position: absolute;
    // 	opacity: 0.3;
    // 	background-image: url(../../assets/image/activity/bgicon17.png);
    // }
    .reward-bottom-box {
      width: 33.3%;
      display: flex;
      justify-content: center;
      align-items: center;
    }

    .reward-bottom-boxA {
      font-size: 0.28rem;
      color: #ffffff;
      display: flex;
      justify-content: center;
      align-items: center;
      line-height: 0.28rem;

      /deep/ .ant-input-number {
        background-color: transparent;
        color: #ffffff;
        // font-size: 36px;
        text-align: center;
        margin: 0 0.15rem;
        border: 0.01rem solid rgb(239, 212, 174);
        border-radius: 0.1rem;
        font-size: 0.3rem;
        height: 0.45rem;
        width: 1.3rem;
        overflow: hidden;
      }

      /deep/ .ant-input-number-input {
        text-align: center;
      }
      /deep/ .ant-input-number-handler-wrap {
        display: none;
      }

      .caret-left {
        width: 0.22rem;
        height: 0.22rem;
      }

      .caret-right {
        width: 0.22rem;
        height: 0.22rem;
      }

      .reward-type {
        width: 1.8rem;
        height: 0.36rem;
        background-color: #000000;
        border-color: #ffe087;
        box-shadow: 0 0 10px 0 #ff8a00, inset 0 0 10px 0 #640101;
        text-align: center;
        @at-root line-height: 0.36rem;
        margin: 0 0.2rem;
      }
    }

    .reward-bottom-boxB {
      width: 3.7rem;
      height: 0.8rem;
      background-image: url(../../assets/image/activity/01_slices/15.png);
      background-size: 100%;
      background-repeat: no-repeat;
      font-size: 0.36rem;
      color: #ffffff;
      text-align: center;
      line-height: 0.8rem;
      cursor: pointer;
    }

    .reward-bottom-boxC {
      width: 1.4rem;
      height: 0.5rem;
      background-image: url(../../assets/image/activity/01_slices/3.png);
      background-size: 100%;
      font-size: 0.36rem;
      color: #ffffff;
      line-height: 0.36rem;
      cursor: pointer;
      transition: all 0.6s;

      &:hover {
        color: #ff8a00;
      }
    }
  }

  .lucky {
    position: fixed;
    width: 90vw;
    height: 88vh;
    left: 5vw;
    top: 4vw;
    z-index: 100;
    // background-color: rgb(255, 188, 158);
    // border: 2px solid rgb(225, 209, 69);
    background-image: url(../../assets/image/activity/03_slices/1.png);
    background-size: 100% 100%;

    // animation-duration:1s;//重新设置动画时间
    // -webkit-animation-delay:5s;//延迟执行动画
    // animation-delay:5s;
    // display: flex;
    // justify-items: center;
    // align-items: center;
    .lucky-name {
      width: 3.7rem;
      height: 0.8rem;
      position: absolute;
      left: 50%;
      margin-top: -0.4rem;
      margin-left: -1.85rem;
      z-index: 1;
    }

    .lucky-icon {
      width: 0.38rem;
      height: 0.38rem;
      background-image: url(../../assets/image/activity/02_slices/6.png);
      position: absolute;
      right: 0.5rem;
      top: 0.5rem;
      background-size: 100%;
      transition: all 0.6s;
      z-index: 99;
      cursor: pointer;
      transition: all 0.6s;
    }

    .lucky-icon:hover {
      transform: scale(1.2, 1.2);
      background-image: url(../../assets/image/activity/02_slices/6.png);
    }

    .uper4 {
      width: 1.6rem;
      height: 0.3rem;
      position: absolute;
      bottom: -0.15rem;
      right: -0.6rem;
    }

    .uper2 {
      width: 2.4rem;
      height: 2rem;
      position: absolute;
      bottom: 0rem;
      right: -0.7rem;
      z-index: 2;
    }

    .uper1 {
      width: 2.1rem;
      height: 1.7rem;
      position: absolute;
      bottom: 1.1rem;
      right: -0.56rem;
    }

    .lucky-mian {
      width: 100%;
      height: 100%;
      display: flex;
      justify-content: center;
      align-items: center;
      position: absolute;
      left: 0;
      top: 0;
    }

    .lucky-box {
      min-width: 5rem;
      height: 5.3rem;
      background-color: rgba(255, 255, 255, 0.2);
      // left: 50%;
      // margin-left: -2.5rem;
      // top: 50%;
      // margin-top: -2.6rem;
      // position: absolute;
      display: flex;
      padding: 0.3rem;
      background-color: rgb(255, 70, 70);
      margin-top: 0.2rem;
      border-radius: 10px;

      .lucky-box-l {
        margin-right: 0.2rem;
        font-size: 0.28rem;
        color: #ffffff;
        text-align: center;

        .lucky-l-img {
          width: 1.8rem;
          height: 1.8rem;
          margin-bottom: 0.2rem;

          img {
            width: 100%;
            height: 100%;
            border-radius: 50%;
          }
        }
      }

      .lucky-box-r {
        font-size: 0.36rem;
        color: #ffffff;
        writing-mode: vertical-lr;
        /*从左向右 从右向左是 writing-mode: vertical-rl;*/
        writing-mode: tb-lr;
        /*IE浏览器的从左向右 从右向左是 writing-mode: tb-rl；*/
      }
    }

    .lucky-user-box {
      width: 100%;
      //   height: 100%;
      // background-color: rgba(0, 0, 0, 0.4);
      // position: absolute;
      // top: 50%;
      // margin-top: -2.6rem;
      // left: 50%;
      // margin-left: -7rem;
      overflow: auto;
      // border-radius: 10px;
      padding: 0.5rem 0.4rem;

      h3 {
        // color: #FFFFFF;
        // font-size: 34px;
        text-align: center;
        font-size: 24px;
        font-family: Source Han Serif CN;
        font-weight: bold;
        color: #fee7bd;
      }

      .lucky-user-list {
        width: 100%;
        height: 100%;
        // background-color: #000000;
        // padding: 1rem 0.4rem;

        .lucky-user-list-cent {
          width: 100%;
          display: flex;
          justify-content: center;
          align-items: center;
          height: 6.8rem;
          flex-wrap: wrap;
          overflow: auto;

          &::-webkit-scrollbar {
            width: 5px;
            height: 10px;

            background-color: #b5b1b1;
          }

          &::-webkit-scrollbar-track {
            -webkit-box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.3);
            border-radius: 10px;
            background-color: black;
          }

          &::-webkit-scrollbar-thumb {
            border-radius: 10px;
            -webkit-box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.3);
            background-color: #b5b1b1;
          }

          .lucky-cent {
            width: 18%;
            // text-align: center;
            font-size: 0.24rem;
            color: #ffffff;
            margin: 0.1rem;
            display: flex;
            justify-content: center;
            position: relative;
            .zc {
              position: absolute;
              right: 0.2rem;
              top: -0.2rem;
              width: 0.7rem;
              height: 0.7rem;
              background-image: url(../../assets/image/activity/03_slices/zc.png);
              background-size: 100% 100%;
              display: flex;
              justify-content: center;
              align-items: center;
              z-index: 100;
              img {
                width: 0.46rem;
                height: 0.22rem;
              }
            }
            .img {
              width: 2.1rem;
              // height: 2.7rem;
              background-image: url(../../assets/image/activity/02_slices/5.png);
              background-size: 100% 100%;
              padding: 0.23rem;
              text-align: center;
              position: relative;
              img {
                width: 100%;
                border-radius: 10px;
                // height: 100%;
                // border-radius: 50%;
              }

              span {
                display: block;
                margin-top: 0.2rem;
                font-size: 0.24rem;
                font-family: Source Han Serif CN;
                font-weight: bold;
                color: #ffffff;
              }

              .text {
                font-family: Source Han Serif CN;
                font-weight: 500;
                color: #ffffff;
                flex: 1;
                margin-left: 0rem;
                display: block;
                margin-top: 0rem;

                span {
                  font-size: 0.14rem !important;
                  margin-top: 0rem;
                  display: block;
                }
              }

              .zc {
                z-index: 100;
                position: absolute;
                right: -0.2rem;
                top: -0.2rem;
                width: 0.7rem;
                height: 0.7rem;
                background-image: url(../../assets/image/activity/03_slices/zc.png);
                background-size: 100% 100%;
                display: flex;
                justify-content: center;
                align-items: center;
                img {
                  width: 0.46rem;
                  height: 0.22rem;
                }
              }
            }

            .imgA {
              width: 3.1rem;
              //   height: 3.7rem;
            }

            .text {
              font-size: 0.16rem;
              font-family: Source Han Serif CN;
              font-weight: 500;
              color: #ffffff;
              flex: 1;
              margin-left: 0.2rem;
              display: block;
              margin-top: 0.7rem;
              margin-top: 70px;

              span {
                margin-top: 0.2rem;
                display: block;
              }
            }
          }
        }
      }

      .custom-slick-arrow {
        width: 25px;
        height: 25px;
        font-size: 25px;
        color: #fff;
        background-color: rgba(31, 45, 61, 0.11);
        opacity: 0.3;
        z-index: 100;
      }

      .custom-slick-arrow:before {
        display: none;
      }

      .custom-slick-arrow:hover {
        opacity: 0.5;
      }
    }
  }

  .open-lucky {
    width: 17.48rem;
    height: 6.2rem;
    background-image: url(../../assets/image/activity/03_slices/1.png);
    background-size: 100% 100%;
    position: absolute;
    top: 0.8rem;
    left: 50%;
    transform: translateX(-50%);
    display: flex;
    align-items: center;
    justify-content: center;
    flex-wrap: wrap;
    padding: 0.5rem 0.6rem;

    .box {
      width: 20%;
      // margin: 0.2rem 0;
      display: flex;
      align-items: center;
      justify-content: center;
      position: relative;
    }

    .open-lucky-box {
      width: 3.2rem;
      height: 3.2rem; // 200px
      background-image: url(../../assets/image/activity/03_slices/3.png);
      background-size: 100% 100%;
      padding: 0.05rem;
      display: flex;
      justify-content: center;
      align-items: center;
      transform: rotate(360deg);
      -webkit-transition: -webkit-transform 0.5s linear;
      transition: transform 0.5s linear;
      -webkit-animation: spin 0.5s linear 1s 5 alternate;
      animation: spin 0.5s linear infinite;
      position: absolute;
    }

    img {
      // height: 100%;
      width: 80%;

      border-radius: 50%;
    }

    @-webkit-keyframes spin {
      from {
        -webkit-transform: rotate(0deg);
      }

      to {
        -webkit-transform: rotate(360deg);
      }
    }

    @-webkit-keyframes spin {
      from {
        -webkit-transform: rotate(0deg);
      }

      to {
        -webkit-transform: rotate(360deg);
      }
    }

    @keyframes spin {
      from {
        transform: rotate(0deg);
      }

      to {
        transform: rotate(360deg);
      }
    }

    .open-lucky-boxA {
      width: 2rem;
      height: 2rem;
    }

    .open-lucky-imgA {
      width: 1.8rem;
      height: 1.8rem;
    }
  }
}

.btn-11 {
  font-family: "Lato", sans-serif;
  background: transparent;
  cursor: pointer;
  transition: all 0.3s ease;
  position: relative;
  display: inline-block;
  box-shadow: inset 2px 2px 2px 0px rgba(255, 255, 255, 0.5),
    7px 7px 20px 0px rgba(0, 0, 0, 0.1), 4px 4px 5px 0px rgba(0, 0, 0, 0.1);
  outline: none;
  // margin: 30px;
  border: none;
  // background: rgb(251, 33, 117);
  /* background: linear-gradient(0deg, rgba(251, 33, 117, 1) 0%, rgba(234, 76, 137, 1) 100%); */
  color: #fff;
  overflow: hidden;
}

.btn-11:hover {
  text-decoration: none;
  color: #fff;
}

.btn-11:before {
  position: absolute;
  content: "";
  display: inline-block;
  top: -180px;
  left: 0;
  width: 30px;
  height: 100%;
  background-color: #fff;
  animation: shiny-btn1 2s ease-in-out infinite;
}

.btn-11:hover {
  opacity: 0.7;
}

.btn-11:active {
  box-shadow: 4px 4px 6px 0 rgba(255, 255, 255, 0.3),
    -4px -4px 6px 0 rgba(116, 125, 136, 0.2),
    inset -4px -4px 6px 0 rgba(255, 255, 255, 0.2),
    inset 4px 4px 6px 0 rgba(0, 0, 0, 0.2);
}

@-webkit-keyframes shiny-btn1 {
  0% {
    -webkit-transform: scale(0) rotate(45deg);
    opacity: 0;
  }

  80% {
    -webkit-transform: scale(0) rotate(45deg);
    opacity: 0.5;
  }

  81% {
    -webkit-transform: scale(4) rotate(45deg);
    opacity: 1;
  }

  100% {
    -webkit-transform: scale(50) rotate(45deg);
    opacity: 0;
  }
}

.custom-slick-arrow {
  width: 0.25rem;
  height: 0.25rem;
  font-size: 25px;
  color: #fff;
  // background-color: rgba(31, 45, 61, 0.11);
  opacity: 0.3;
  transition: all 0.6s;
  z-index: 100;
}

.ant-carousel .slick-prev,
.ant-carousel .slick-next {
  color: #ffffff;
}

.custom-slick-arrow:hover {
  opacity: 1 !important;
}

.ant-carousel .slick-prev::before,
.ant-carousel .slick-next::before {
  content: "";
}
</style>
